<template>
    <div>
        <app-page-header title="About Us" subtitle="We're a global venture builder focused on connecting the world’s most influential leaders. Our main initiative is C-Suite Circle, the world’s largest network of senior business leaders. We also offer consulting services in technology, marketing, and strategy to help our clients succeed." light-theme />

        <section class="our-history">
             <b-container>
                <timeline />
            </b-container>
        </section>

        <section class="values text-center">
            <b-container>
                <h2 class="title mb-5">Community Values</h2>
                <div class="row mt-5">
                    <div v-for="(value,index) in values" :key="index" class="col-lg-4 mb-4">
                        <div class="d-md-flex text-md-left text-lg-center align-items-md-center d-lg-block">
                            <div class="image">
                                <img :src="value.icon" />
                            </div>
                            <div class="mt-3">
                                <h5>{{ value.title }}</h5>
                                <p>{{ value.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </b-container>
        </section>

        <!--
        <section class="advisory">
            <b-container>
                <h2 class="title">Our Advisors</h2>
                <div class="row">
                    <a class="col-md-6 col-lg-4 mb-4" v-for="(people, index) in advisors" :key="index" :href="people.linkedin" target="_blank">
                        <people-card :people="people" />
                    </a>
                </div>
            </b-container>
        </section>
        -->

        <section class="employment">
            <b-container>
                <div class="row align-items-center">
                    <div class="col-md-5 order-md-2">
                        <h2>Work with us</h2>
                        <p>We welcome applications from talented developers, product/project managers, and community builders across the world.</p>
                    </div>
                    <div class="col-md-7 order-md-1">
                        <div class="image-wrapper">
                            <btn href="https://csuitecircle.recruitee.com/" primary rounded target="_blank">See opportunities</btn>
                        </div>
                    </div>
                </div>
            </b-container>
        </section>

        <section class="get-in-touch">
            <b-container>
                <h2 class="title">Get In Touch</h2>
                <p>We'd love to chat. Use the form below, or email us at <a href="mailto:hello@csuitegroup.com">hello@csuitegroup.com</a>.</p>
                <contact-form></contact-form>
            </b-container>
        </section>

        <section class="contact-details">
           <b-container>
                <div class="row">
                    <div class="headquaters">
                        <h2 class="title">Headquarters</h2>
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <h6>C-Suite Group</h6>
                                <a href="mailto:hello@csuitegroup.com">hello@csuitegroup.com</a>
                            </div>
                            <div class="col-md-6 address mb-2">
                                <address>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12.868" height="15.533" viewBox="0 0 12.868 15.533"><g transform="translate(-5.885 -1.104)"><path class="a" d="M6.434,15.533h0L1.884,10.984a6.435,6.435,0,0,1,9.1-9.1,6.434,6.434,0,0,1,0,9.1L6.435,15.533Zm0-12.153A2.987,2.987,0,1,0,9.421,6.369,2.991,2.991,0,0,0,6.433,3.381Z" transform="translate(5.885 1.104)" /></g></svg>
                                    C-Suite Group
                                    <div>36 Sam Leong Road, Singapore 207926</div>
                                </address>
                            </div>
                        </div>
                        <a href="https://www.visitsingapore.com/en/" target="_blank" class="mt-md-4 d-block">
                            <img src="@/assets/img/stb-logo.png">
                        </a>
                    </div>
                    <div class="google-map">
                        <google-map :markers="marker" :zoom="parseFloat(1)"></google-map>
                    </div>
                </div>
           </b-container>
        </section>
    </div>
</template>

<script>
import PeopleData from '@/data/people.json';
import AdvisorData from '@/data/advisors.json';
import AppPageHeader from '@/components/global/AppPageHeader';
import GoogleMap from '@/components/global/GoogleMap';
import ContactForm from '@/components/about/ContactForm';
// import PeopleCard from '@/components/people/PeopleCard';
import Btn from '@/components/global/Btn';
import Timeline from '@/components/about/Timeline';

export default {
    name: 'about',

    components: {
        AppPageHeader,
        GoogleMap,
        ContactForm,
        // PeopleCard,
        Btn,
        Timeline,
    },

    data() {
        return {
            marker: {
                latitude: '1.309829',
                longitude: '103.856403',
            },
            values: [
                {
                    icon: require('@/assets/img/Icon-Reciprocity.png'),
                    title: 'Reciprocity',
                    description: 'Opportunity is a positive-sum game. As a community, we share our time, connections, and expertise with others to help them succeed.',
                },
                {
                    icon: require('@/assets/img/Icon-Transparence.png'),
                    title: 'Transparency',
                    description: 'No person, organization, or system is perfect. Transparency at every level leads to better outcomes for everyone.',
                },
                {
                    icon: require('@/assets/img/Icon-Generosity.png'),
                    title: 'Generosity',
                    description: 'As members of the <<one percent>>, we recognise our unique privilege and embrace our responsibility to society as a whole.',
                },
            ],
            team: PeopleData,
            advisors: AdvisorData,
        };
    },
};
</script>

<style lang="scss" scoped>
    h2.title {
        font-size: 42px;
        font-weight: 900;
        text-align: center;
        margin-bottom: 30px;
    }

    img {
        max-width: 100%;
    }

    .our-history {
        background-color: #ffffff;
        padding: 50px 0;
        background-image: url('~@/assets/img/business-people-talking-in-corridor@2x.png');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        @include media-breakpoint-up(md) {
            background-attachment: fixed;
        }
        @include media-breakpoint-up(lg) {
            padding: 120px 0;
        }
    }

    .values {
        padding: 40px 0 20px;
        background-color:white;

        @include media-breakpoint-up(lg) {
            padding: 60px 0 30px;
        }

        p {
            font-size: 15px;
            color: #505B64;
            line-height: 24px;
        }

        h5 {
            font-weight: 700;
        }

        img {
            @include media-breakpoint-up(md) {
                max-width: 245px;
                margin-right: 40px;
            }

            @include media-breakpoint-up(lg) {
                max-width: 100%;
                margin-right: 0;
            }
        }
    }

    .advisory {
        padding: 60px 0 30px;
        @include media-breakpoint-up(md) {
            padding: 60px 0;
        }
        .title {
            margin-bottom: 70px;
        }
        a {
            text-decoration: none;
            color: inherit;
        }
    }

    .employment {
        padding: 20px 0 40px;
        text-align: center;
        @include media-breakpoint-up(md) {
            text-align: left;
        }
        .image-wrapper {
            background-image: url('~@/assets/img/Photos@2x.png');
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
            padding: 160px 0;
            text-align: center;
        }

        .btn-primary {
            padding: 7px 30px;
            font-size: 18px;
            font-weight: 400;
        }

        h2 {
            font-size: 42px;
            font-weight: 900;
            color: $primary;
            margin-top: 10px;
            margin-bottom: 20px;
        }

        p {
            color: #505B64;
            font-size: 15px;
            line-height: 24px;
            max-width: 345px;
            margin: 0 auto;
            @include media-breakpoint-up(md) {
                margin: 0 0 46px;
            }
        }
    }

    .get-in-touch {
        background-color: #ffffff;
        position: relative;
        background-image: url('~@/assets/img/Get-in-touch-decor.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 47%;

        @include media-breakpoint-up(md) {
            background-size: contain;
            background-position: bottom right;
        }

        .container {
            padding-top: 80px;
            padding-bottom: 80px
        }

        h2 {
            margin-bottom: 20px;
        }

        p {
            max-width: 550px;
            margin: 0 auto;
            text-align: center;
            margin-bottom: 40px;
            color: #505B64;
        }

        form {
            padding: 45px 25px 25px;

            @include media-breakpoint-up(md) {
                padding: 70px 130px;
            }
        }
    }

    .contact-details {
        background-color: #0B0124;
        color: #FFFFFF;
        padding: 60px 0 50px;
        text-align: center;
        @include media-breakpoint-up(md) {
            text-align: left;
        }

        h2 {
            margin-bottom: 40px;
            @include media-breakpoint-up(md) {
                text-align: left;
            }
        }

        h6 {
            font-size: 18px;
            font-weight: 700;
        }

        .headquaters {
            font-weight: 600;
            @include make-col-ready();
            @include media-breakpoint-up(md) {
                @include make-col(12);
            }
            @include media-breakpoint-up(lg) {
                @include make-col(6.7);
            }
            a {
                color: #B5C0C7;
                font-size: 16px;
            }
        }

        .address {
            font-size: 16px;
            line-height: 24px;
            color: #B5C0C7;

            svg {
                fill: #B5C0C7;
                margin-left: -21px;
                margin-right: 6px;
            }
        }

        .google-map {
            margin: 30px auto;
            max-width: 400px;
            @include make-col-ready();
            @include media-breakpoint-up(md) {
                @include make-col(12);
                margin-top: 50px;
            }
            @include media-breakpoint-up(lg) {
                @include make-col(5.3);
                margin: 0;
                padding: 0 30px;
            }
        }
    }
</style>
